import $ from 'jquery';
// import PageScroll from '../../util/pageScroll';

const Navigation = {
    init() {
        const $body = $('body');
        const $mobileNavToggle = $('.js-nav-toggle');
        const $subMenuToggles = $('.js-sub-menu-toggle');
        const $subMenuClose = $('.js-sub-menu-close')

        let navOpen = false;

        $mobileNavToggle.on('click', function(e) {
            if (navOpen) {
                $body.removeClass('main_nav_open');
                // PageScroll.unlock();
            } else {
                $body.addClass('main_nav_open');
                // PageScroll.lock();
            }
            navOpen = !navOpen;
        });

        $subMenuToggles.on('click', function(e) {
            e.preventDefault();

            const $parentMenuItem = $(this).parent('.menu-item');

            if ($parentMenuItem.hasClass('open')) {
                $parentMenuItem.removeClass('open');
            } else {
                $parentMenuItem.addClass('open');
            }
        });

        $subMenuClose.on('click', function(e) {
            e.preventDefault();

            const $parentMenuItem = $(this).parents('.menu-item');

            if ($parentMenuItem.hasClass('open')) {
                $parentMenuItem.removeClass('open');
            }
        });
    }
}

export default Navigation;